/* eslint-disable */
// This is auto generated code, do not edit directly

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/** Date (isoformat) */
	Date: { input: any; output: any };
	/** Date with time (isoformat) */
	DateTime: { input: any; output: any };
	UUID: { input: any; output: any };
};

export type AcademicStatus = {
	__typename?: 'AcademicStatus';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

/** Represents an address */
export type Address = {
	__typename?: 'Address';
	buildingIdentifier_V?: Maybe<Scalars['String']['output']>;
	businessCda_V?: Maybe<Scalars['Boolean']['output']>;
	cbsa_V?: Maybe<Scalars['String']['output']>;
	cityCda_V?: Maybe<Scalars['String']['output']>;
	cityIntl_V?: Maybe<Scalars['String']['output']>;
	countryCda_V?: Maybe<Scalars['String']['output']>;
	dpvConfirmedIndicator_V?: Maybe<Scalars['String']['output']>;
	fax1_V?: Maybe<Scalars['String']['output']>;
	faxCda_V?: Maybe<Scalars['String']['output']>;
	hospitalCampus?: Maybe<HcoResourceNotFound>;
	/** @deprecated Use hospitalCampus */
	hospitalCampusName_V?: Maybe<Scalars['String']['output']>;
	/** @deprecated Use hospitalCampus */
	hospitalCampusVeevaid_V?: Maybe<Scalars['ID']['output']>;
	latitudeCda_V?: Maybe<Scalars['Float']['output']>;
	longitudeCda_V?: Maybe<Scalars['Float']['output']>;
	phone1_V?: Maybe<Scalars['String']['output']>;
	phone2_V?: Maybe<Scalars['String']['output']>;
	phoneCda_V?: Maybe<Scalars['String']['output']>;
	postalCodeCda_V?: Maybe<Scalars['String']['output']>;
	postalCodeFullUs_V?: Maybe<Scalars['String']['output']>;
	postalCodeIntl_V?: Maybe<Scalars['String']['output']>;
	postalCodePrimary_V?: Maybe<Scalars['String']['output']>;
	primaryCda_V?: Maybe<Scalars['Boolean']['output']>;
	stateCda_V?: Maybe<Scalars['String']['output']>;
	statusCda_V?: Maybe<Scalars['String']['output']>;
	statusCda_VId?: Maybe<Scalars['String']['output']>;
	streetAddress1Cda_V?: Maybe<Scalars['String']['output']>;
	streetAddress1Intl_V?: Maybe<Scalars['String']['output']>;
	streetAddress2Cda_V?: Maybe<Scalars['String']['output']>;
	streetAddress2Intl_V?: Maybe<Scalars['String']['output']>;
	subAdministrativeArea_V?: Maybe<Scalars['String']['output']>;
	subStateAdminUnit_V?: Maybe<Scalars['String']['output']>;
	vid_V: Scalars['ID']['output'];
};

export enum AffiliationDirection {
	Child = 'CHILD',
	Parent = 'PARENT'
}

export enum AffiliationGroupSort {
	HcpRollup = 'HCP_ROLLUP',
	IsActive = 'IS_ACTIVE',
	IsPrimary = 'IS_PRIMARY',
	Name = 'NAME'
}

export enum AuthenticationChallenge {
	MagicLink = 'MAGIC_LINK',
	Password = 'PASSWORD'
}

export type AutocompleteInput = {
	searchString: Scalars['String']['input'];
	size?: Scalars['Int']['input'];
};

/** Equivalent to HTTP 400. Bad Request */
export type BadRequest = {
	__typename?: 'BadRequest';
	errors: Array<Scalars['String']['output']>;
	message: Scalars['String']['output'];
};

export enum CsvDelimiter {
	Comma = 'COMMA',
	Semicolon = 'SEMICOLON'
}

export type ClearRecentProfileStatus = {
	__typename?: 'ClearRecentProfileStatus';
	entityTypes: Array<EntityType>;
};

export type ClearRecentSearchStatus = {
	__typename?: 'ClearRecentSearchStatus';
	entityTypes: Array<EntityType>;
};

export type CountRange = {
	__typename?: 'CountRange';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

export type Country = {
	__typename?: 'Country';
	count: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	sortOrder?: Maybe<Scalars['Int']['output']>;
	states: Array<State>;
};

export type Dcr = {
	__typename?: 'DCR';
	attachments: Array<DcrAttachment>;
	completedAt?: Maybe<Scalars['DateTime']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	/** Returns the current entity related to the DCR, if available */
	currentEntity?: Maybe<Hcphco>;
	displayStatus: DcrDisplayStatus;
	entityData: Scalars['String']['output'];
	entityType: DcrEntityType;
	fieldResults?: Maybe<Array<DcrFieldResult>>;
	id: Scalars['UUID']['output'];
	networkId?: Maybe<Scalars['ID']['output']>;
	note?: Maybe<Scalars['String']['output']>;
	resolutionNotes?: Maybe<Array<DcrResolutionNote>>;
	result?: Maybe<DcrResultStatus>;
	status: DcrStatus;
	type: DcrType;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DcrAddressInput = {
	cbsa_VId?: InputMaybe<Scalars['ID']['input']>;
	cityCda_V?: InputMaybe<Scalars['String']['input']>;
	countryCda_VId?: InputMaybe<Scalars['ID']['input']>;
	fax1_V?: InputMaybe<Scalars['String']['input']>;
	faxCda_V?: InputMaybe<Scalars['String']['input']>;
	phone1_V?: InputMaybe<Scalars['String']['input']>;
	phoneCda_V?: InputMaybe<Scalars['String']['input']>;
	postalCodeCda_V?: InputMaybe<Scalars['String']['input']>;
	postalCodeFullUs_V?: InputMaybe<Scalars['String']['input']>;
	primaryCda_V?: InputMaybe<Scalars['Boolean']['input']>;
	stateCda_VId?: InputMaybe<Scalars['ID']['input']>;
	statusCda_VId?: InputMaybe<Scalars['ID']['input']>;
	streetAddress1Cda_V?: InputMaybe<Scalars['String']['input']>;
	streetAddress2Cda_V?: InputMaybe<Scalars['String']['input']>;
	subAdministrativeArea_V?: InputMaybe<Scalars['String']['input']>;
	subStateAdminUnit_V?: InputMaybe<Scalars['String']['input']>;
	vid_V?: InputMaybe<Scalars['ID']['input']>;
};

export type DcrAttachment = {
	__typename?: 'DCRAttachment';
	fileContentType: Scalars['String']['output'];
	fileName: Scalars['String']['output'];
	fileSize: Scalars['Int']['output'];
	id: Scalars['UUID']['output'];
	viewUrl: Scalars['String']['output'];
};

export type DcrBadRequestForbidden = BadRequest | Dcr | Forbidden;

export type DcrCreateInput = {
	attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	entity: DcrOneOfEntityInput;
	note?: InputMaybe<Scalars['String']['input']>;
};

export enum DcrDisplayStatus {
	ChangeAccepted = 'CHANGE_ACCEPTED',
	ChangePartial = 'CHANGE_PARTIAL',
	ChangePendingreview = 'CHANGE_PENDINGREVIEW',
	ChangeProcessing = 'CHANGE_PROCESSING',
	ChangeRejected = 'CHANGE_REJECTED'
}

export enum DcrEntityType {
	Hco = 'HCO',
	Hcp = 'HCP'
}

export type DcrFieldResult = {
	__typename?: 'DCRFieldResult';
	field: Scalars['String']['output'];
	finalValue?: Maybe<Scalars['String']['output']>;
	group: Scalars['String']['output'];
	previousValue?: Maybe<Scalars['String']['output']>;
	requestedValue?: Maybe<Scalars['String']['output']>;
	result?: Maybe<DcrFieldResultStatus>;
};

export enum DcrFieldResultStatus {
	ChangeAccepted = 'CHANGE_ACCEPTED',
	ChangeAdded = 'CHANGE_ADDED',
	ChangeAlreadyapplied = 'CHANGE_ALREADYAPPLIED',
	ChangeModified = 'CHANGE_MODIFIED',
	ChangeRejected = 'CHANGE_REJECTED'
}

export type DcrForbiddenResourceNotFound = Dcr | Forbidden | ResourceNotFound;

export type DcrhcoAutocompleteInput = {
	countryId: Scalars['String']['input'];
	searchString: Scalars['String']['input'];
	size?: Scalars['Int']['input'];
};

export type DcrhcoInput = {
	academicStatus_VId?: InputMaybe<Scalars['ID']['input']>;
	addresses_V?: InputMaybe<Array<DcrAddressInput>>;
	businessType_VId?: InputMaybe<Scalars['ID']['input']>;
	countHcp_VId?: InputMaybe<Scalars['ID']['input']>;
	countPrescriber_VId?: InputMaybe<Scalars['ID']['input']>;
	emailCda_V?: InputMaybe<Scalars['String']['input']>;
	faxCda_V?: InputMaybe<Scalars['String']['input']>;
	hcoNameCda_V?: InputMaybe<Scalars['String']['input']>;
	hcoOwnership_VId?: InputMaybe<Scalars['ID']['input']>;
	hcoTaxId_V?: InputMaybe<Scalars['String']['input']>;
	hcoTypeCda_VId?: InputMaybe<Scalars['ID']['input']>;
	hcoTypeLocal_VId?: InputMaybe<Scalars['ID']['input']>;
	internationalName_V?: InputMaybe<Scalars['String']['input']>;
	licenses_V?: InputMaybe<Array<DcrLicenseInput>>;
	nhidCda_V?: InputMaybe<Scalars['String']['input']>;
	officePhoneCda_V?: InputMaybe<Scalars['String']['input']>;
	parentHcos_V?: InputMaybe<Array<DcrParentHcoInput>>;
	primaryCountry_V?: InputMaybe<Scalars['ID']['input']>;
	spec1Local_VId?: InputMaybe<Scalars['ID']['input']>;
	spec2Local_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty1_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty2_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty3_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty4_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty5_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty6_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty7_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty8_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty9_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty10_VId?: InputMaybe<Scalars['ID']['input']>;
	statusCda_VId?: InputMaybe<Scalars['ID']['input']>;
	typeOfHierarchy_VId?: InputMaybe<Scalars['ID']['input']>;
	vid_V?: InputMaybe<Scalars['ID']['input']>;
	websiteCda_V?: InputMaybe<Scalars['String']['input']>;
};

export type DcrhcpInput = {
	URL1_V?: InputMaybe<Scalars['String']['input']>;
	addresses_V?: InputMaybe<Array<DcrAddressInput>>;
	birthYear_V?: InputMaybe<Scalars['Int']['input']>;
	dataPrivacyOptOut_V?: InputMaybe<Scalars['Boolean']['input']>;
	degree1Cda_VId?: InputMaybe<Scalars['ID']['input']>;
	email2_V?: InputMaybe<Scalars['String']['input']>;
	email3_V?: InputMaybe<Scalars['String']['input']>;
	email4_V?: InputMaybe<Scalars['String']['input']>;
	email5_V?: InputMaybe<Scalars['String']['input']>;
	emailCda_V?: InputMaybe<Scalars['String']['input']>;
	faxCda_V?: InputMaybe<Scalars['String']['input']>;
	firstNameCda_V?: InputMaybe<Scalars['String']['input']>;
	gender_VId?: InputMaybe<Scalars['ID']['input']>;
	gradSchool_V?: InputMaybe<Scalars['String']['input']>;
	gradYear_V?: InputMaybe<Scalars['Int']['input']>;
	hcpStatus_VId?: InputMaybe<Scalars['ID']['input']>;
	hcpTaxId_V?: InputMaybe<Scalars['String']['input']>;
	hcpTypeCda_VId?: InputMaybe<Scalars['ID']['input']>;
	hcpTypeLocal_VId?: InputMaybe<Scalars['ID']['input']>;
	inCurrentPecos_V?: InputMaybe<Scalars['Boolean']['input']>;
	internationalName_V?: InputMaybe<Scalars['String']['input']>;
	languageCda_VId?: InputMaybe<Scalars['ID']['input']>;
	lastNameCda_V?: InputMaybe<Scalars['String']['input']>;
	licenses_V?: InputMaybe<Array<DcrLicenseInput>>;
	middleNameCda_V?: InputMaybe<Scalars['String']['input']>;
	nhid2_V?: InputMaybe<Scalars['String']['input']>;
	nhidCda_V?: InputMaybe<Scalars['String']['input']>;
	officePhoneCda_V?: InputMaybe<Scalars['String']['input']>;
	parentHcos_V?: InputMaybe<Array<DcrParentHcoInput>>;
	phone2_V?: InputMaybe<Scalars['String']['input']>;
	prefixCda_V?: InputMaybe<Scalars['String']['input']>;
	prescriberCda_V?: InputMaybe<Scalars['Boolean']['input']>;
	primaryCountry_V?: InputMaybe<Scalars['ID']['input']>;
	spec1Cda_VId?: InputMaybe<Scalars['ID']['input']>;
	spec1Local_VId?: InputMaybe<Scalars['ID']['input']>;
	spec2Local_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty1_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty2_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty3_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty4_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty5_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty6_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty7_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty8_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty9_VId?: InputMaybe<Scalars['ID']['input']>;
	specialty10_VId?: InputMaybe<Scalars['ID']['input']>;
	statusCda_VId?: InputMaybe<Scalars['ID']['input']>;
	suffixCda_V?: InputMaybe<Scalars['String']['input']>;
	telehealth_V?: InputMaybe<Scalars['Boolean']['input']>;
	vid_V?: InputMaybe<Scalars['ID']['input']>;
	websiteCda_V?: InputMaybe<Scalars['String']['input']>;
};

export type DcrLicenseInput = {
	expirationDate_V?: InputMaybe<Scalars['Date']['input']>;
	licenseNumber_V?: InputMaybe<Scalars['String']['input']>;
	licenseStatus_VId?: InputMaybe<Scalars['ID']['input']>;
	typeValue_V?: InputMaybe<Scalars['String']['input']>;
	vid_V?: InputMaybe<Scalars['ID']['input']>;
};

export type DcrOneOfEntityInput =
	| { hco: DcrhcoInput; hcp?: never }
	| { hco?: never; hcp: DcrhcpInput };

export type DcrParentHcoInput = {
	isPrimaryRelationship_V?: InputMaybe<Scalars['Boolean']['input']>;
	jobTitle_V?: InputMaybe<Scalars['String']['input']>;
	parentHcoStatus_VId?: InputMaybe<Scalars['ID']['input']>;
	parentHcoVid_V?: InputMaybe<Scalars['String']['input']>;
	relationshipType_VId?: InputMaybe<Scalars['ID']['input']>;
	role_V?: InputMaybe<Scalars['String']['input']>;
	typeOfRelationship_VId?: InputMaybe<Scalars['ID']['input']>;
	vid_V?: InputMaybe<Scalars['ID']['input']>;
};

export type DcrResolutionNote = {
	__typename?: 'DCRResolutionNote';
	comment: Scalars['String']['output'];
};

export enum DcrResultStatus {
	ChangeAccepted = 'CHANGE_ACCEPTED',
	ChangePartial = 'CHANGE_PARTIAL',
	ChangeRejected = 'CHANGE_REJECTED'
}

export type DcrResults = {
	__typename?: 'DCRResults';
	results: Array<Dcr>;
	statusFacets: Array<DcrStatusFacet>;
	total: Scalars['Int']['output'];
};

export type DcrResultsForbiddenBadRequest = BadRequest | DcrResults | Forbidden;

export enum DcrStatus {
	ChangeCancelled = 'CHANGE_CANCELLED',
	ChangeInqueue = 'CHANGE_INQUEUE',
	ChangeNew = 'CHANGE_NEW',
	ChangePartiallyprocessed = 'CHANGE_PARTIALLYPROCESSED',
	ChangePendingreview = 'CHANGE_PENDINGREVIEW',
	ChangeProcessed = 'CHANGE_PROCESSED',
	Draft = 'DRAFT',
	Failed = 'FAILED',
	Sent = 'SENT'
}

export type DcrStatusFacet = {
	__typename?: 'DCRStatusFacet';
	count: Scalars['Int']['output'];
	status: DcrDisplayStatus;
};

export enum DcrType {
	Add = 'ADD',
	Change = 'CHANGE'
}

export type DownloadOptions = {
	delimiter?: CsvDelimiter;
};

export type EitherSearchInput =
	| { hco: HcoSearchAndFiltersInput; hcp?: never }
	| { hco?: never; hcp: HcpSearchAndFiltersInput };

export type EmailValue = {
	__typename?: 'EmailValue';
	value: Scalars['String']['output'];
};

export type EmailValueForbidden = EmailValue | Forbidden;

export enum EntityType {
	Hco = 'HCO',
	Hcp = 'HCP'
}

/** Event created */
export type EventCreated = {
	__typename?: 'EventCreated';
	messageId?: Maybe<Scalars['String']['output']>;
};

export type EventCreatedBadRequest = BadRequest | EventCreated;

/** Equivalent to HTTP 403. Insufficient permissions */
export type Forbidden = {
	__typename?: 'Forbidden';
	message: Scalars['String']['output'];
};

export type ForbiddenBadRequestSignInResult =
	| BadRequest
	| Forbidden
	| SignInResult;

export type ForbiddenServiceUnavailableInitiateAuthResult =
	| Forbidden
	| InitiateAuthResult
	| ServiceUnavailable;

/** Represents a health care organization */
export type Hco = {
	__typename?: 'HCO';
	academicStatus?: Maybe<AcademicStatus>;
	addresses: Array<Address>;
	/** Paginated, searchable HCPs affiliated to an HCO (direct + indirect via the HCO hierarchy), with the default ODCO-1174 sort. Intended for single-profile views (e.g. the Affiliated HCPs modal). Per-call filter arguments make this resolver unsuitable for DataLoader batching; do not select this field on lists of HCOs. */
	affiliatedHcpSearch: HcoAffiliatedHcpsResultsBadRequest;
	/**
	 * Paginated, grouped, searchable affiliations for an HCO (ODCO-1315). Set `directions` plus exactly one of `relationshipTypeIds` (include-only) or `excludeRelationshipTypeIds` (exclude) for the Parent HCO / Child HCO / Partners views (PRTN = the Partners With type). Combinations: Parent HCO = directions [PARENT] + excludeRelationshipTypeIds [PRTN]; Child HCO = directions [CHILD] + excludeRelationshipTypeIds [PRTN]; Partners = directions [PARENT, CHILD] + relationshipTypeIds [PRTN]. `sortBy` is an ordered list of keys (IS_ACTIVE, IS_PRIMARY, NAME, HCP_ROLLUP) applied left-to-right; defaults to [IS_ACTIVE, IS_PRIMARY, NAME] when omitted. Partners (both directions) returns empty `hcoTypes` facets.
	 * Per-call filter arguments make this resolver unsuitable for DataLoader batching; do not select this field on lists of HCOs.
	 */
	affiliationSearch: HcoAffiliationsResultsBadRequest;
	/** @deprecated Use affiliationSearch which supports name search, HCO type filtering, and surfaces validation errors as a BadRequest. */
	affiliations: HcoAffiliationsResults;
	alternateName1_V?: Maybe<Scalars['String']['output']>;
	businessType_V?: Maybe<Scalars['String']['output']>;
	/** @deprecated Use affiliations instead */
	childhcos: Array<ParentHco>;
	/** @deprecated Use hcpCount instead. */
	countHcp_V?: Maybe<Scalars['String']['output']>;
	/** Primary country code for the HCO */
	countryId?: Maybe<Scalars['ID']['output']>;
	/** Name to display: alternateName1_V when it is embedded in a '<parent> / <department>' hcoNameCda_V and the HCO has a primary parent; otherwise hcoNameCda_V. */
	displayName_V?: Maybe<Scalars['String']['output']>;
	emailCda_V?: Maybe<Scalars['String']['output']>;
	faxCda_V?: Maybe<Scalars['String']['output']>;
	hcoHierarchyType?: Maybe<HcoHierarchyType>;
	hcoNameCda_V?: Maybe<Scalars['String']['output']>;
	hcoNameEnglish_V?: Maybe<Scalars['String']['output']>;
	hcoNameIntl_V?: Maybe<Scalars['String']['output']>;
	hcoNameShort_V?: Maybe<Scalars['String']['output']>;
	hcoTaxId_V?: Maybe<Scalars['String']['output']>;
	hcoType?: Maybe<HcoType>;
	/** @deprecated Use hcoType instead */
	hcoTypeCda_V?: Maybe<Scalars['String']['output']>;
	hcpCount?: Maybe<CountRange>;
	/** @deprecated Use affiliationSearch which embeds a filter-aware inactiveCount in its result type. */
	inactiveAffiliationCount: Scalars['Int']['output'];
	internationalNameCda_V?: Maybe<Scalars['String']['output']>;
	kaiser_V?: Maybe<Scalars['Boolean']['output']>;
	keyHcoNetwork_V?: Maybe<Scalars['Boolean']['output']>;
	licenses: Array<License>;
	localHcoType?: Maybe<LocalHcoType>;
	localSpecialties: Array<LocalSpecialty>;
	mainOrganization?: Maybe<HcoResourceNotFound>;
	majorClassOfTrade_V?: Maybe<Scalars['String']['output']>;
	nhidCda_V?: Maybe<Scalars['String']['output']>;
	officePhoneCda_V?: Maybe<Scalars['String']['output']>;
	ownership?: Maybe<HcoOwnership>;
	/** @deprecated Use affiliations instead */
	parenthcos: Array<ParentHco>;
	prescriberCount?: Maybe<CountRange>;
	primaryLocalSpecialty?: Maybe<LocalSpecialty>;
	secondaryLocalSpecialty?: Maybe<LocalSpecialty>;
	specialty1_V?: Maybe<Scalars['String']['output']>;
	specialty2_V?: Maybe<Scalars['String']['output']>;
	specialty3_V?: Maybe<Scalars['String']['output']>;
	specialty4_V?: Maybe<Scalars['String']['output']>;
	specialty5_V?: Maybe<Scalars['String']['output']>;
	specialty6_V?: Maybe<Scalars['String']['output']>;
	specialty7_V?: Maybe<Scalars['String']['output']>;
	specialty8_V?: Maybe<Scalars['String']['output']>;
	specialty9_V?: Maybe<Scalars['String']['output']>;
	specialty10_V?: Maybe<Scalars['String']['output']>;
	statusCda_V?: Maybe<Scalars['String']['output']>;
	statusCda_VId?: Maybe<Scalars['String']['output']>;
	topOrganization?: Maybe<HcoResourceNotFound>;
	vaDodAffiliated_V?: Maybe<Scalars['Boolean']['output']>;
	veevaid_V: Scalars['ID']['output'];
	vid_V: Scalars['ID']['output'];
	websiteCda_V?: Maybe<Scalars['String']['output']>;
};

/** Represents a health care organization */
export type HcoAddressesArgs = {
	includeInactive?: Scalars['Boolean']['input'];
};

/** Represents a health care organization */
export type HcoAffiliatedHcpSearchArgs = {
	paginationInput: PaginationInput;
	payload: HcoAffiliatedHcpsSearchInput;
};

/** Represents a health care organization */
export type HcoAffiliationSearchArgs = {
	paginationInput: PaginationInput;
	payload: HcoAffiliationSearchInput;
};

/** Represents a health care organization */
export type HcoAffiliationsArgs = {
	paginationInput: PaginationInput;
	payload: HcoAffiliationsInput;
};

/** Represents a health care organization */
export type HcoInactiveAffiliationCountArgs = {
	direction: AffiliationDirection;
};

export type HcoAffiliatedHcpsResults = {
	__typename?: 'HCOAffiliatedHcpsResults';
	hcpTypes: Array<HcpTypeWithCount>;
	inactiveCount: Scalars['Int']['output'];
	paginationMetadata: PaginationMetadata;
	results: Array<Hcp>;
};

export type HcoAffiliatedHcpsResultsBadRequest =
	| BadRequest
	| HcoAffiliatedHcpsResults;

export type HcoAffiliatedHcpsSearchInput = {
	hcpTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
	includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
	nameSearch?: InputMaybe<Scalars['String']['input']>;
};

export type HcoAffiliationSearchInput = {
	directions?: InputMaybe<Array<AffiliationDirection>>;
	excludeRelationshipTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcoTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
	nameSearch?: InputMaybe<Scalars['String']['input']>;
	relationshipTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	sortBy?: InputMaybe<Array<AffiliationGroupSort>>;
};

export type HcoAffiliationsInput = {
	direction: AffiliationDirection;
	includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HcoAffiliationsResults = {
	__typename?: 'HCOAffiliationsResults';
	hcoTypes: Array<HcoTypeWithCount>;
	inactiveCount: Scalars['Int']['output'];
	paginationMetadata: PaginationMetadata;
	results: Array<ParentHco>;
};

export type HcoAffiliationsResultsBadRequest =
	| BadRequest
	| HcoAffiliationsResults;

export type HcoAutocompleteResult = {
	__typename?: 'HCOAutocompleteResult';
	hco: Hco;
};

export type HcoAutocompleteResults = {
	__typename?: 'HCOAutocompleteResults';
	results: Array<HcoAutocompleteResult>;
};

export type HcoAutocompleteResultsBadRequest =
	| BadRequest
	| HcoAutocompleteResults;

export type HcoAutocompleteResultsForbiddenBadRequest =
	| BadRequest
	| Forbidden
	| HcoAutocompleteResults;

export type HcohcpResourceNotFound = Hco | Hcp | ResourceNotFound;

export type HcoHierarchyType = {
	__typename?: 'HCOHierarchyType';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

/** Input data to GET an entity */
export type HcoInput = {
	/** VID v1 */
	vid: Scalars['ID']['input'];
};

export type HcoOwnership = {
	__typename?: 'HCOOwnership';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

export type HcoResourceNotFound = Hco | ResourceNotFound;

export type HcoSearchAndFilters = {
	__typename?: 'HCOSearchAndFilters';
	countries: Array<Country>;
	inactiveCount: Scalars['Int']['output'];
	search: HcoSearchResultsBadRequest;
	types: Array<HcoType>;
};

export type HcoSearchAndFiltersSearchArgs = {
	paginationInput: PaginationInput;
};

export type HcoSearchAndFiltersBadRequest = BadRequest | HcoSearchAndFilters;

export type HcoSearchAndFiltersInput = {
	countries?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcoTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
	includeInactive?: Scalars['Boolean']['input'];
	searchString?: InputMaybe<Scalars['String']['input']>;
	states?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HcoSearchAndFiltersType = {
	__typename?: 'HCOSearchAndFiltersType';
	countries?: Maybe<Array<Scalars['ID']['output']>>;
	hcoTypes?: Maybe<Array<Scalars['ID']['output']>>;
	includeInactive: Scalars['Boolean']['output'];
	searchString?: Maybe<Scalars['String']['output']>;
	states?: Maybe<Array<Scalars['ID']['output']>>;
};

export type HcoSearchAndFiltersTypeHcpSearchAndFiltersType =
	| HcoSearchAndFiltersType
	| HcpSearchAndFiltersType;

export type HcoSearchInput = {
	countries?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcoTypes?: InputMaybe<Array<HcoTypeInput>>;
	includeInactive?: Scalars['Boolean']['input'];
	searchString?: InputMaybe<Scalars['String']['input']>;
	states?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a HCO search result */
export type HcoSearchResult = {
	__typename?: 'HCOSearchResult';
	hco: Hco;
};

/** Represents HCO search results */
export type HcoSearchResults = {
	__typename?: 'HCOSearchResults';
	/** @deprecated Internal */
	_performance_timers: PerformanceTimers;
	pagination: PaginationMetadata;
	results: Array<HcoSearchResult>;
};

export type HcoSearchResultsBadRequest = BadRequest | HcoSearchResults;

/** Represents a HCO type */
export type HcoType = {
	__typename?: 'HCOType';
	count: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type HcoTypeInput = {
	id: Scalars['String']['input'];
};

/** An HCO type paired with an aggregate count. */
export type HcoTypeWithCount = {
	__typename?: 'HCOTypeWithCount';
	count: Scalars['Int']['output'];
	hcoType: HcoType;
};

/** Input data to GET multiple entities */
export type HcOsInput = {
	/** VID v1 */
	vids: Array<Scalars['ID']['input']>;
};

/** Represents a health care provider */
export type Hcp = {
	__typename?: 'HCP';
	URL1_V?: Maybe<Scalars['String']['output']>;
	addresses: Array<Address>;
	affiliatedHcoTypes: Array<HcoType>;
	/** The HCP's single most-relevant affiliation within the given HCO's hierarchy family, for context-sensitive display on affiliated-HCP lists (e.g. an HCO profile's Affiliated HCPs section). */
	affiliationInHco?: Maybe<ParentHco>;
	/** Paginated, searchable affiliations for an HCP. Intended for single-profile views (e.g. the Affiliations modal). Per-call filter arguments make this resolver unsuitable for DataLoader batching; do not select this field on lists of HCPs. */
	affiliationSearch: HcpAffiliationsResultsBadRequest;
	/** @deprecated Use affiliationSearch which supports name search and surfaces validation errors as a BadRequest. */
	affiliations: HcpAffiliationsResults;
	/** Provides a comma-separated list of medical degrees. By default, the primary is not included. */
	allDegreeCda_V?: Maybe<Scalars['String']['output']>;
	birthYear_V?: Maybe<Scalars['Int']['output']>;
	/** Primary country code for the HCP */
	countryId?: Maybe<Scalars['ID']['output']>;
	dataPrivacyOptOut_V?: Maybe<Scalars['Boolean']['output']>;
	degree1Cda_V?: Maybe<Scalars['String']['output']>;
	email?: Maybe<EmailValueForbidden>;
	email2?: Maybe<EmailValueForbidden>;
	email3?: Maybe<EmailValueForbidden>;
	email4?: Maybe<EmailValueForbidden>;
	email5?: Maybe<EmailValueForbidden>;
	/** @deprecated Use email instead */
	emailCda_V?: Maybe<Scalars['String']['output']>;
	/** Number of emails on record for this HCP (0-5). Not permission- or country-gated, so the UI can show an 'unlock to view' affordance when emails exist but the individual email fields are redacted for users lacking viewer:email_view. */
	emailCount: Scalars['Int']['output'];
	faxCda_V?: Maybe<Scalars['String']['output']>;
	firstNameCda_V?: Maybe<Scalars['String']['output']>;
	firstNameIntl_V?: Maybe<Scalars['String']['output']>;
	gender_V?: Maybe<Scalars['String']['output']>;
	gradSchool_V?: Maybe<Scalars['String']['output']>;
	gradYear_V?: Maybe<Scalars['Int']['output']>;
	hcpReasonStatus?: Maybe<HcpReasonStatus>;
	/** Provides a list of HCP Specialties */
	hcpSpecialties: Array<HcpSpecialty>;
	hcpStatus_V?: Maybe<Scalars['String']['output']>;
	hcpTaxId_V?: Maybe<Scalars['String']['output']>;
	hcpType?: Maybe<HcpType>;
	/** @deprecated Use hcpType instead */
	hcpTypeCdaId?: Maybe<Scalars['String']['output']>;
	/** @deprecated Use hcpType instead */
	hcpTypeCda_V?: Maybe<Scalars['String']['output']>;
	inCurrentPecos_V?: Maybe<Scalars['Boolean']['output']>;
	/** @deprecated Use affiliationSearch which embeds a filter-aware inactiveCount in its result type. */
	inactiveAffiliationCount: Scalars['Int']['output'];
	/** @deprecated Use internationalName_V instead */
	internationalNameCda_V?: Maybe<Scalars['String']['output']>;
	internationalName_V?: Maybe<Scalars['String']['output']>;
	kaiser_V?: Maybe<Scalars['Boolean']['output']>;
	languageCda_V?: Maybe<Scalars['String']['output']>;
	lastNameCda_V?: Maybe<Scalars['String']['output']>;
	lastNameIntl_V?: Maybe<Scalars['String']['output']>;
	licenses: Array<License>;
	localHcpType?: Maybe<LocalHcpType>;
	localSpecialties: Array<LocalSpecialty>;
	mainOrganization?: Maybe<HcoResourceNotFound>;
	middleNameCda_V?: Maybe<Scalars['String']['output']>;
	middleNameIntl_V?: Maybe<Scalars['String']['output']>;
	nhid2_V?: Maybe<Scalars['String']['output']>;
	nhidCda_V?: Maybe<Scalars['String']['output']>;
	nickname_V?: Maybe<Scalars['String']['output']>;
	officePhoneCda_V?: Maybe<Scalars['String']['output']>;
	/** @deprecated Use affiliations instead */
	parenthcos: Array<ParentHco>;
	phone2_V?: Maybe<Scalars['String']['output']>;
	prefixCda_V?: Maybe<Scalars['String']['output']>;
	prescriberCda_V?: Maybe<Scalars['Boolean']['output']>;
	primaryAffiliation?: Maybe<HcoResourceNotFound>;
	primaryLocalSpecialty?: Maybe<LocalSpecialty>;
	secondaryLocalSpecialty?: Maybe<LocalSpecialty>;
	/**
	 * Provides list of specialties.
	 * @deprecated Use hcpSpecialties, they carry extra data regarding the relationship
	 */
	specialties: Array<Specialty>;
	specialty1_V?: Maybe<Scalars['String']['output']>;
	specialty2_V?: Maybe<Scalars['String']['output']>;
	specialty3_V?: Maybe<Scalars['String']['output']>;
	specialty4_V?: Maybe<Scalars['String']['output']>;
	specialty5_V?: Maybe<Scalars['String']['output']>;
	specialty6_V?: Maybe<Scalars['String']['output']>;
	specialty7_V?: Maybe<Scalars['String']['output']>;
	specialty8_V?: Maybe<Scalars['String']['output']>;
	specialty9_V?: Maybe<Scalars['String']['output']>;
	specialty10_V?: Maybe<Scalars['String']['output']>;
	statusCda_V?: Maybe<Scalars['String']['output']>;
	statusCda_VId?: Maybe<Scalars['String']['output']>;
	suffixCda_V?: Maybe<Scalars['String']['output']>;
	telehealth_V?: Maybe<Scalars['Boolean']['output']>;
	topOrganization?: Maybe<HcoResourceNotFound>;
	veevaid_V: Scalars['ID']['output'];
	vid_V: Scalars['ID']['output'];
	websiteCda_V?: Maybe<Scalars['String']['output']>;
};

/** Represents a health care provider */
export type HcpAddressesArgs = {
	includeInactive?: Scalars['Boolean']['input'];
};

/** Represents a health care provider */
export type HcpAffiliationInHcoArgs = {
	hcoVid: Scalars['ID']['input'];
	includeInactive?: Scalars['Boolean']['input'];
};

/** Represents a health care provider */
export type HcpAffiliationSearchArgs = {
	paginationInput: PaginationInput;
	payload: HcpAffiliationSearchInput;
};

/** Represents a health care provider */
export type HcpAffiliationsArgs = {
	paginationInput: PaginationInput;
	payload: HcpAffiliationsInput;
};

/** Represents a health care provider */
export type HcpAllDegreeCda_VArgs = {
	includePrimary?: Scalars['Boolean']['input'];
};

export type HcpAffiliationSearchInput = {
	includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
	nameSearch?: InputMaybe<Scalars['String']['input']>;
};

export type HcpAffiliationsInput = {
	includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HcpAffiliationsResults = {
	__typename?: 'HCPAffiliationsResults';
	hcoTypes: Array<HcoTypeWithCount>;
	inactiveCount: Scalars['Int']['output'];
	paginationMetadata: PaginationMetadata;
	results: Array<ParentHco>;
};

export type HcpAffiliationsResultsBadRequest =
	| BadRequest
	| HcpAffiliationsResults;

export type Hcphco = Hco | Hcp;

/** Input data to GET an entity */
export type HcpInput = {
	/** VID v1 */
	vid: Scalars['ID']['input'];
};

export type HcpReasonStatus = {
	__typename?: 'HCPReasonStatus';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

export type HcpResourceNotFound = Hcp | ResourceNotFound;

export type HcpSearchAndFilters = {
	__typename?: 'HCPSearchAndFilters';
	countries: Array<Country>;
	hcoTypes: Array<HcoType>;
	inactiveCount: Scalars['Int']['output'];
	search: HcpSearchResultsBadRequest;
	specialtyGroups: Array<SpecialtyGroup>;
	types: Array<HcpType>;
};

export type HcpSearchAndFiltersSearchArgs = {
	paginationInput: PaginationInput;
};

export type HcpSearchAndFiltersBadRequest = BadRequest | HcpSearchAndFilters;

export type HcpSearchAndFiltersInput = {
	countries?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcoTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcos?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcpTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
	includeInactive?: Scalars['Boolean']['input'];
	searchString?: InputMaybe<Scalars['String']['input']>;
	specialties?: InputMaybe<Array<Scalars['ID']['input']>>;
	specialtyGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
	states?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HcpSearchAndFiltersType = {
	__typename?: 'HCPSearchAndFiltersType';
	countries?: Maybe<Array<Scalars['ID']['output']>>;
	hcoTypes?: Maybe<Array<Scalars['ID']['output']>>;
	hcos?: Maybe<Array<Scalars['ID']['output']>>;
	hcpTypes?: Maybe<Array<Scalars['ID']['output']>>;
	includeInactive: Scalars['Boolean']['output'];
	searchString?: Maybe<Scalars['String']['output']>;
	specialties?: Maybe<Array<Scalars['ID']['output']>>;
	specialtyGroups?: Maybe<Array<Scalars['ID']['output']>>;
	states?: Maybe<Array<Scalars['ID']['output']>>;
};

export type HcpSearchInput = {
	countries?: InputMaybe<Array<Scalars['String']['input']>>;
	hcoTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcos?: InputMaybe<Array<Scalars['ID']['input']>>;
	hcpTypes?: InputMaybe<Array<Scalars['String']['input']>>;
	includeInactive?: Scalars['Boolean']['input'];
	searchString?: InputMaybe<Scalars['String']['input']>;
	specialties?: InputMaybe<Array<Scalars['String']['input']>>;
	specialtyGroups?: InputMaybe<Array<Scalars['String']['input']>>;
	states?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents a HCP search result */
export type HcpSearchResult = {
	__typename?: 'HCPSearchResult';
	hcp: Hcp;
};

/** Represents HCP search results */
export type HcpSearchResults = {
	__typename?: 'HCPSearchResults';
	/** @deprecated Internal */
	_performance_timers: PerformanceTimers;
	pagination: PaginationMetadata;
	results: Array<HcpSearchResult>;
};

export type HcpSearchResultsBadRequest = BadRequest | HcpSearchResults;

/** Represents the relation between a HCP and a Specialty */
export type HcpSpecialty = {
	__typename?: 'HCPSpecialty';
	primary: Scalars['Boolean']['output'];
	specialty: Specialty;
};

/** Represents a HCP type */
export type HcpType = {
	__typename?: 'HCPType';
	count: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

/** An HCP type paired with an aggregate count. */
export type HcpTypeWithCount = {
	__typename?: 'HCPTypeWithCount';
	count: Scalars['Int']['output'];
	hcpType: HcpType;
};

/** Input data to GET multiple entities */
export type HcPsInput = {
	/** VID v1 */
	vids: Array<Scalars['ID']['input']>;
};

/** Input data for initiating authentication */
export type InitiateAuthInput = {
	username: Scalars['String']['input'];
};

/** Represents an authentication challenge for user authentication */
export type InitiateAuthResult = {
	__typename?: 'InitiateAuthResult';
	challenge: AuthenticationChallenge;
};

/** Represents a license */
export type License = {
	__typename?: 'License';
	address?: Maybe<Address>;
	bestStateLicense_V?: Maybe<Scalars['Boolean']['output']>;
	body_V?: Maybe<Scalars['String']['output']>;
	collabAgreeRequired_V?: Maybe<Scalars['String']['output']>;
	comprehensivePrescriptiveAuthority_V?: Maybe<Scalars['String']['output']>;
	comprehensiveSampleEligibility_V?: Maybe<Scalars['String']['output']>;
	ctrlSubstancePrescriptive_V?: Maybe<Scalars['String']['output']>;
	ctrlSubstanceSample_V?: Maybe<Scalars['String']['output']>;
	deaBusinessActivityCode_V?: Maybe<Scalars['String']['output']>;
	deaPaymentIndicator_V?: Maybe<Scalars['String']['output']>;
	drugSchedule_V?: Maybe<Scalars['String']['output']>;
	expirationDate_V?: Maybe<Scalars['Date']['output']>;
	gracePeriod_V?: Maybe<Scalars['Date']['output']>;
	licenseCertification_V?: Maybe<Scalars['String']['output']>;
	licenseDegree_V?: Maybe<Scalars['String']['output']>;
	licenseEligibility_V?: Maybe<Scalars['String']['output']>;
	licenseNumber_V?: Maybe<Scalars['String']['output']>;
	licenseStatusCondition_V?: Maybe<Scalars['String']['output']>;
	licenseStatus_V?: Maybe<Scalars['String']['output']>;
	licenseSubtype_V?: Maybe<Scalars['String']['output']>;
	licensingBody_V?: Maybe<Scalars['String']['output']>;
	rxaEligible_V?: Maybe<Scalars['String']['output']>;
	sourceAddress_V?: Maybe<Scalars['String']['output']>;
	typeValue_VId?: Maybe<Scalars['String']['output']>;
	type_V?: Maybe<Scalars['String']['output']>;
	vid_V: Scalars['ID']['output'];
};

export type LocalHcoType = {
	__typename?: 'LocalHCOType';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

export type LocalHcpType = {
	__typename?: 'LocalHCPType';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

export type LocalSpecialty = {
	__typename?: 'LocalSpecialty';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

/** Root node for all mutations in OpenData Commercial */
export type Mutation = {
	__typename?: 'Mutation';
	/** Clear recent profile visits */
	clearRecentProfiles: ClearRecentProfileStatus;
	/** Delete all recent searches */
	clearRecentSearches: ClearRecentSearchStatus;
	/** Creates the file to download containing HCO search results */
	createHcoSearchDownload: SearchDownloadLinkForbidden;
	/** Creates the file to download containing HCP search results */
	createHcpSearchDownload: SearchDownloadLinkForbidden;
	/** Delete an unattached DCR attachment */
	deleteDcrAttachment: NoContentForbiddenResourceNotFound;
	/**
	 * Start authenticating a user.
	 * @deprecated Use POST /graphql/auth/initiate-auth (ODCO-1155). Kept during the cookie-auth migration window.
	 */
	initiateAuth: ForbiddenServiceUnavailableInitiateAuthResult;
	postDcr: DcrBadRequestForbidden;
	/**
	 * Sign a user in.
	 * @deprecated Use POST /graphql/auth/sign-in (ODCO-1155). Both cookies are set on the response so cookie-aware clients can rely on this mutation during the migration.
	 */
	signIn: ForbiddenBadRequestSignInResult;
	/**
	 * Sign a Cognito user out.
	 * @deprecated Use POST /graphql/auth/sign-out (ODCO-1155).
	 */
	signOut: SignOutResult;
	/** Track an entity profile view (HCO or HCP) */
	trackEntityProfileView: EventCreatedBadRequest;
	/** Track a page view */
	trackPageView: EventCreated;
	/** Track a search */
	trackSearch: EventCreated;
	/** Update user recent visited profiles */
	updateRecentProfiles: ProfileVisitResourceNotFound;
	/** Update user recent search */
	updateRecentSearches: RecentSearchBadRequest;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationClearRecentProfilesArgs = {
	entityTypes: Array<EntityType>;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationClearRecentSearchesArgs = {
	entityTypes: Array<EntityType>;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationCreateHcoSearchDownloadArgs = {
	downloadOptions?: InputMaybe<DownloadOptions>;
	payload: HcoSearchAndFiltersInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationCreateHcpSearchDownloadArgs = {
	downloadOptions?: InputMaybe<DownloadOptions>;
	payload: HcpSearchAndFiltersInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationDeleteDcrAttachmentArgs = {
	attachmentId: Scalars['ID']['input'];
};

/** Root node for all mutations in OpenData Commercial */
export type MutationInitiateAuthArgs = {
	input: InitiateAuthInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationPostDcrArgs = {
	payload: DcrCreateInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationSignInArgs = {
	input: SignInInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationTrackEntityProfileViewArgs = {
	trackInput: TrackEntityProfileViewInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationTrackPageViewArgs = {
	trackInput: TrackPageViewInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationTrackSearchArgs = {
	trackInput: TrackSearchInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationUpdateRecentProfilesArgs = {
	profileVisit: UpdateRecentProfilesInput;
};

/** Root node for all mutations in OpenData Commercial */
export type MutationUpdateRecentSearchesArgs = {
	searchData: RecentSearchInput;
};

/** Equivalent to HTTP 204. Success without a response body. */
export type NoContent = {
	__typename?: 'NoContent';
	message: Scalars['String']['output'];
};

export type NoContentForbiddenResourceNotFound =
	| Forbidden
	| NoContent
	| ResourceNotFound;

export type PaginationInput = {
	page?: Scalars['Int']['input'];
	pageSize?: Scalars['Int']['input'];
};

/** Pagination metadata */
export type PaginationMetadata = {
	__typename?: 'PaginationMetadata';
	page: Scalars['Int']['output'];
	pageSize: Scalars['Int']['output'];
	total: Scalars['Int']['output'];
	totalPages: Scalars['Int']['output'];
};

export type ParentHco = {
	__typename?: 'ParentHCO';
	childHco: HcoResourceNotFound;
	childVeevaid_V?: Maybe<Scalars['ID']['output']>;
	classOfWork_V?: Maybe<Scalars['String']['output']>;
	hcp: HcpResourceNotFound;
	isPrimaryRelationship_V?: Maybe<Scalars['Boolean']['output']>;
	jobTitle_V?: Maybe<Scalars['String']['output']>;
	parentHco: HcoResourceNotFound;
	parentHcoStatus_VId?: Maybe<Scalars['String']['output']>;
	parentVeevaid_V?: Maybe<Scalars['ID']['output']>;
	relationshipType?: Maybe<RelationshipType>;
	relationshipType_V?: Maybe<Scalars['String']['output']>;
	role_V?: Maybe<Scalars['String']['output']>;
	vid_V: Scalars['ID']['output'];
};

/** Used for debugging and benchmarking. Times are in ms. */
export type PerformanceTimers = {
	__typename?: 'PerformanceTimers';
	entityResolution?: Maybe<Scalars['Int']['output']>;
	namedEntityRecognition?: Maybe<Scalars['Int']['output']>;
	searchCluster?: Maybe<Scalars['Int']['output']>;
};

/** Profile visit data */
export type ProfileVisit = {
	__typename?: 'ProfileVisit';
	lastVisit: Scalars['DateTime']['output'];
	profile: HcohcpResourceNotFound;
};

export type ProfileVisitResourceNotFound = ProfileVisit | ResourceNotFound;

export type ProfileVisitResults = {
	__typename?: 'ProfileVisitResults';
	pagination: PaginationMetadata;
	results: Array<ProfileVisit>;
};

export type ProfileVisitResultsBadRequest = BadRequest | ProfileVisitResults;

/** OpenData Commercial main GraphQL query object */
export type Query = {
	__typename?: 'Query';
	countries: Array<Country>;
	currentUser: User;
	/** HCO Autocomplete tailored for the DCR form */
	dcrHcoAutocomplete: HcoAutocompleteResultsForbiddenBadRequest;
	dcrUnavailableFields: UnavailableFieldsForbiddenBadRequest;
	getDcr: DcrForbiddenResourceNotFound;
	getDcrs: DcrResultsForbiddenBadRequest;
	/** Endpoint to retrieve a single HCO */
	hco: HcoResourceNotFound;
	/**
	 * HCO Autocomplete. Designed for picklists
	 * @deprecated Use dcrHcoAutocomplete instead
	 */
	hcoAutocomplete: HcoAutocompleteResultsBadRequest;
	/**
	 * Returns a static list of HCO countries
	 * @deprecated Replaced by hcoSearchAndFilters
	 */
	hcoCountries: Array<Country>;
	/**
	 * Endpoint to search all HCOs
	 * @deprecated Replaced by hcoSearchAndFilters
	 */
	hcoSearch: HcoSearchResultsBadRequest;
	/** Performs a HCO search and returns the results and filters */
	hcoSearchAndFilters: HcoSearchAndFiltersBadRequest;
	/** Endpoint to retrieve multiple HCOs */
	hcos: Array<Hco>;
	/** Endpoint to retrieve a single HCP */
	hcp: HcpResourceNotFound;
	/**
	 * Returns a static list of HCP countries
	 * @deprecated Please use countries instead
	 */
	hcpCountries: Array<Country>;
	/**
	 * Endpoint to search all HCPs
	 * @deprecated Replaced by hcpSearchAndFilters
	 */
	hcpSearch: HcpSearchResultsBadRequest;
	/** Performs a HCP search and returns the results and filters */
	hcpSearchAndFilters: HcpSearchAndFiltersBadRequest;
	/**
	 * Returns a static list of HCP specialty groups
	 * @deprecated Replaced by hcpSearchAndFilters
	 */
	hcpSpecialtyGroups: Array<SpecialtyGroup>;
	/** Endpoint to retrieve multiple HCPs */
	hcps: Array<Hcp>;
	/** Access recent profiles */
	recentProfiles: ProfileVisitResultsBadRequest;
	/** Access recent searches */
	recentSearches: RecentSearchResultsBadRequest;
	reference: ReferenceResultBadRequest;
	/** Search-as-you-type search that yields HCPs and HCOs */
	searchAsYouType: SearchAsYouTypeResultsBadRequest;
};

/** OpenData Commercial main GraphQL query object */
export type QueryDcrHcoAutocompleteArgs = {
	payload: DcrhcoAutocompleteInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryDcrUnavailableFieldsArgs = {
	countryId: Scalars['ID']['input'];
};

/** OpenData Commercial main GraphQL query object */
export type QueryGetDcrArgs = {
	dcrId: Scalars['UUID']['input'];
};

/** OpenData Commercial main GraphQL query object */
export type QueryGetDcrsArgs = {
	paginationInput: PaginationInput;
	searchInput?: InputMaybe<SearchMyDcRsInput>;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcoArgs = {
	payload: HcoInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcoAutocompleteArgs = {
	payload: AutocompleteInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcoCountriesArgs = {
	searchPayload: HcoSearchInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcoSearchArgs = {
	input: HcoSearchInput;
	paginationInput: PaginationInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcoSearchAndFiltersArgs = {
	searchPayload: HcoSearchAndFiltersInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcosArgs = {
	payload: HcOsInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcpArgs = {
	payload: HcpInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcpCountriesArgs = {
	searchPayload: HcpSearchInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcpSearchArgs = {
	paginationInput: PaginationInput;
	payload: HcpSearchInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcpSearchAndFiltersArgs = {
	searchPayload: HcpSearchAndFiltersInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcpSpecialtyGroupsArgs = {
	searchPayload: HcpSearchInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryHcpsArgs = {
	payload: HcPsInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryRecentProfilesArgs = {
	entityTypes: Array<EntityType>;
	paginationInput: PaginationInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryRecentSearchesArgs = {
	entityTypes: Array<EntityType>;
	paginationInput: PaginationInput;
};

/** OpenData Commercial main GraphQL query object */
export type QueryReferenceArgs = {
	payload: ReferenceInput;
};

/** OpenData Commercial main GraphQL query object */
export type QuerySearchAsYouTypeArgs = {
	searchPayload: SearchAsYouTypeInput;
};

/** Recent search */
export type RecentSearch = {
	__typename?: 'RecentSearch';
	entityType: EntityType;
	lastSearch: Scalars['DateTime']['output'];
	payload: HcoSearchAndFiltersTypeHcpSearchAndFiltersType;
	searchKey: Scalars['String']['output'];
};

export type RecentSearchBadRequest = BadRequest | RecentSearch;

export type RecentSearchInput = {
	queryString: Scalars['String']['input'];
	search: EitherSearchInput;
	/** If not provided will be derived from search_string by sorting its fields. */
	searchKey?: InputMaybe<Scalars['String']['input']>;
};

export type RecentSearchResults = {
	__typename?: 'RecentSearchResults';
	pagination: PaginationMetadata;
	results: Array<RecentSearch>;
};

export type RecentSearchResultsBadRequest = BadRequest | RecentSearchResults;

export type Reference = {
	__typename?: 'Reference';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

export type ReferenceInput = {
	countryId?: InputMaybe<Scalars['String']['input']>;
	referenceType: ReferenceType;
};

export type ReferenceResult = {
	__typename?: 'ReferenceResult';
	results: Array<Reference>;
};

export type ReferenceResultBadRequest = BadRequest | ReferenceResult;

export enum ReferenceType {
	AcademicStatus = 'ACADEMIC_STATUS',
	Cbsa = 'CBSA',
	Country = 'COUNTRY',
	CountRange = 'COUNT_RANGE',
	HcoBusinessType = 'HCO_BUSINESS_TYPE',
	HcoHierarchyType = 'HCO_HIERARCHY_TYPE',
	HcoOwnership = 'HCO_OWNERSHIP',
	HcoType = 'HCO_TYPE',
	HcpGender = 'HCP_GENDER',
	HcpStatus = 'HCP_STATUS',
	HcpStatusReason = 'HCP_STATUS_REASON',
	HcpType = 'HCP_TYPE',
	Language = 'LANGUAGE',
	LicenseStatus = 'LICENSE_STATUS',
	LocalHcoType = 'LOCAL_HCO_TYPE',
	LocalHcpType = 'LOCAL_HCP_TYPE',
	LocalSpecialty = 'LOCAL_SPECIALTY',
	MedicalDegree = 'MEDICAL_DEGREE',
	ObjectEntityType = 'OBJECT_ENTITY_TYPE',
	RelationshipType = 'RELATIONSHIP_TYPE',
	RelationStatus = 'RELATION_STATUS',
	RelationType = 'RELATION_TYPE',
	Specialty = 'SPECIALTY',
	SpecialtyLocal = 'SPECIALTY_LOCAL',
	State = 'STATE',
	Status = 'STATUS'
}

export type RelationshipType = {
	__typename?: 'RelationshipType';
	code: Scalars['ID']['output'];
	localizedName?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
};

/** Equivalent to HTTP 404. Resource not found */
export type ResourceNotFound = {
	__typename?: 'ResourceNotFound';
	message: Scalars['String']['output'];
};

export type SearchAsYouTypeInput = {
	searchString: Scalars['String']['input'];
	size?: Scalars['Int']['input'];
};

/** Used for debugging and benchmarking. Times are in ms. */
export type SearchAsYouTypePerformanceTimers = {
	__typename?: 'SearchAsYouTypePerformanceTimers';
	entityResolution?: Maybe<Scalars['Int']['output']>;
	namedEntityRecognitionCluster?: Maybe<Scalars['Int']['output']>;
	namedEntityRecognitionFull?: Maybe<Scalars['Int']['output']>;
	searchCluster?: Maybe<Scalars['Int']['output']>;
};

export type SearchAsYouTypeResult = {
	__typename?: 'SearchAsYouTypeResult';
	entity: Hcphco;
	score: Scalars['Float']['output'];
};

export type SearchAsYouTypeResults = {
	__typename?: 'SearchAsYouTypeResults';
	/** @deprecated Internal */
	_performance_timers: SearchAsYouTypePerformanceTimers;
	results: Array<SearchAsYouTypeResult>;
};

export type SearchAsYouTypeResultsBadRequest =
	| BadRequest
	| SearchAsYouTypeResults;

/** Contains URL and filename to download HCP search results */
export type SearchDownloadLink = {
	__typename?: 'SearchDownloadLink';
	downloadUrl: Scalars['String']['output'];
	filename: Scalars['String']['output'];
	/** @deprecated Obsolete */
	gdprRemovedRows: Scalars['Int']['output'];
	gdprRows: Scalars['Int']['output'];
	totalRows: Scalars['Int']['output'];
};

export type SearchDownloadLinkForbidden = Forbidden | SearchDownloadLink;

export type SearchMyDcRsInput = {
	searchString?: InputMaybe<Scalars['String']['input']>;
	statuses?: InputMaybe<Array<DcrDisplayStatus>>;
};

/** Equivalent to a HTTP 503. */
export type ServiceUnavailable = {
	__typename?: 'ServiceUnavailable';
	message: Scalars['String']['output'];
};

/** Input data to sign in with password */
export type SignInInput = {
	magicLinkToken?: InputMaybe<Scalars['String']['input']>;
	password?: InputMaybe<Scalars['String']['input']>;
	username?: InputMaybe<Scalars['String']['input']>;
};

/** Contains the result after authentication */
export type SignInResult = {
	__typename?: 'SignInResult';
	expiresIn: Scalars['Int']['output'];
	idToken: Scalars['String']['output'];
};

/** Contains the result after sign-out */
export type SignOutResult = {
	__typename?: 'SignOutResult';
	message: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

/** Represents a Specialty */
export type Specialty = {
	__typename?: 'Specialty';
	count?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	specialtyGroup: SpecialtyGroup;
};

/** Represents a Specialty Group */
export type SpecialtyGroup = {
	__typename?: 'SpecialtyGroup';
	count?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	specialties: Array<Specialty>;
};

export type State = {
	__typename?: 'State';
	count: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type TrackEntityProfileViewInput = {
	/** VeevaId V2 */
	veevaId: Scalars['ID']['input'];
};

export type TrackPageViewInput = {
	pagePath: Scalars['String']['input'];
};

export type TrackSearchInput = {
	entityType: EntityType;
	queryString: Scalars['String']['input'];
	resultsCount: Scalars['Int']['input'];
};

export type UnavailableFields = {
	__typename?: 'UnavailableFields';
	results: Array<Scalars['String']['output']>;
};

export type UnavailableFieldsForbiddenBadRequest =
	| BadRequest
	| Forbidden
	| UnavailableFields;

export type UpdateRecentProfilesInput = {
	/** VeevaId V2 */
	veevaId: Scalars['ID']['input'];
};

/** Represents a user */
export type User = {
	__typename?: 'User';
	dcrEnabled: Scalars['Boolean']['output'];
	email: Scalars['String']['output'];
	id: Scalars['UUID']['output'];
};
